import React from "react";
import pix1x from "../../assets/pix/pix-symbol-48.png";
import pix2x from "../../assets/pix/pix-symbol-96.png";
import pix4x from "../../assets/pix/pix-symbol-192.png";

const Icon = ({children, size = 18}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="currentColor"
        viewBox="0 0 16 16"
        aria-hidden="true"
    >
        {children}
    </svg>
);

// Line icons, drawn on the same 16px grid as the filled ones above, in the
// current text color.
const LineIcon = ({children, size = 16}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 16 16"
        aria-hidden="true"
    >
        {children}
    </svg>
);

export const SendIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M14.5 1.5 1.5 6l5.5 3 3 5.5zM14.5 1.5 7 9" />
    </LineIcon>
);

export const CheckIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="m3 8.5 3.5 3.5L13 4.5" />
    </LineIcon>
);

export const CheckCircleIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <circle cx="8" cy="8" r="6.25" />
        <path d="m5.2 8.3 2 2 3.6-4.2" />
    </LineIcon>
);

export const CashIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <rect x="1.5" y="4" width="13" height="8" rx="1" />
        <circle cx="8" cy="8" r="1.75" />
    </LineIcon>
);

export const XCircleIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <circle cx="8" cy="8" r="6.25" />
        <path d="m5.8 5.8 4.4 4.4M10.2 5.8l-4.4 4.4" />
    </LineIcon>
);

export const QrIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <rect x="1.75" y="1.75" width="4.5" height="4.5" rx=".5" />
        <rect x="9.75" y="1.75" width="4.5" height="4.5" rx=".5" />
        <rect x="1.75" y="9.75" width="4.5" height="4.5" rx=".5" />
        <path d="M9.75 9.75h1.5v1.5h-1.5zM13 9.75v1.5M10.5 13h3.5M13 13v1.25" />
    </LineIcon>
);

export const CopyIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <rect x="5.5" y="5.5" width="8" height="8" rx="1" />
        <path d="M10.5 5.5v-2a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2" />
    </LineIcon>
);

export const RefreshIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M13 8a5 5 0 1 1-1.6-3.7M13 2.5v3h-3" />
    </LineIcon>
);

export const BoltIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M9 1.5 3.5 9H8l-1 5.5L12.5 7H8z" />
    </LineIcon>
);

export const HistoryIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M2.5 8a5.5 5.5 0 1 0 1.8-4.07M2.5 2.5v2.75h2.75M8 5v3.25l2 1.25" />
    </LineIcon>
);

export const BellIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M8 1.75c-2.5 0-4 1.9-4 4.25 0 3-1.25 4.25-1.75 4.75h11.5C13.25 10.25 12 9 12 6c0-2.35-1.5-4.25-4-4.25zM6.5 13a1.5 1.5 0 0 0 3 0" />
    </LineIcon>
);

export const PaletteIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M8 1.75a6.25 6.25 0 1 0 0 12.5c1 0 1.5-.65 1.5-1.35 0-.9-.75-1.15-.75-2 0-.7.55-1.15 1.25-1.15h1.5a2.25 2.25 0 0 0 2.25-2.25C13.75 4.4 11.2 1.75 8 1.75zM5 8.25h.01M6.5 5h.01M10 5h.01" />
    </LineIcon>
);

export const XIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="m4 4 8 8M12 4l-8 8" />
    </LineIcon>
);

export const LoginIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M9.5 2.5h3v11h-3M6 5.5 8.5 8 6 10.5M8.5 8h-7" />
    </LineIcon>
);

export const PlusIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M8 3v10M3 8h10" />
    </LineIcon>
);

export const KeyIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <circle cx="5.5" cy="10.5" r="3" />
        <path d="m7.6 8.4 6-6M11.5 4.5 13 6M9.5 6.5 11 8" />
    </LineIcon>
);

export const SlidersIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M2 4.5h12M2 11.5h12" />
        <circle cx="5.5" cy="4.5" r="1.75" />
        <circle cx="10.5" cy="11.5" r="1.75" />
    </LineIcon>
);

export const LogoutIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M6.5 2.5h-3v11h3M10 5.5 12.5 8 10 10.5M12.5 8h-7" />
    </LineIcon>
);

export const TableIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <rect x="2" y="3" width="12" height="10" rx="1" />
        <path d="M2 6.5h12M6.5 6.5V13" />
    </LineIcon>
);

export const ChartIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M3 13V8M8 13V3M13 13V6" />
    </LineIcon>
);

export const ChevronLeftIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="m10 3-5 5 5 5" />
    </LineIcon>
);

export const ChevronRightIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="m6 3 5 5-5 5" />
    </LineIcon>
);

export const GlobeIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <circle cx="8" cy="8" r="6.25" />
        <path d="M1.75 8h12.5M8 1.75c-2 2-2.8 4-2.8 6.25S6 12.25 8 14.25c2-2 2.8-4 2.8-6.25S10 3.75 8 1.75" />
    </LineIcon>
);

export const ClockIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <circle cx="8" cy="8" r="6.25" />
        <path d="M8 4.5V8l2.5 1.5" />
    </LineIcon>
);

export const FileTextIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M3.5 1.5h6l3 3v10h-9zM9.5 1.5v3h3M5.5 8h5M5.5 10.5h5" />
    </LineIcon>
);

export const ChatIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M2.5 2.5h11v8h-6l-3 3v-3h-2z" />
    </LineIcon>
);

export const UserIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <circle cx="8" cy="5.25" r="2.75" />
        <path d="M2.75 14a5.25 5.25 0 0 1 10.5 0" />
    </LineIcon>
);

export const NoteIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M3 2.5h10v7.5l-3.5 3.5H3zM9.5 13.5V10H13M5.5 5.5h5M5.5 8h3" />
    </LineIcon>
);

export const ListIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M6 4h8M6 8h8M6 12h8M2.5 4h.01M2.5 8h.01M2.5 12h.01" />
    </LineIcon>
);

export const DeviceIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <rect x="4.5" y="1.5" width="7" height="13" rx="1.5" />
        <path d="M7 12.25h2" />
    </LineIcon>
);

export const PercentIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="m12.5 3.5-9 9" />
        <circle cx="4.75" cy="4.75" r="1.5" />
        <circle cx="11.25" cy="11.25" r="1.5" />
    </LineIcon>
);

export const ShopIcon = ({size = 16}) => (
    <LineIcon size={size}>
        <path d="M2 6.5 3 2.5h10l1 4M2 6.5a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0M3 9v5h10V9M6.5 14v-3h3v3" />
    </LineIcon>
);

export const TrashIcon = () => (
    <Icon>
        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
    </Icon>
);

export const ShareIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5m-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
    </Icon>
);

export const LinkIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
        <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
    </Icon>
);

export const PrinterIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
    </Icon>
);

export const BoxIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" />
    </Icon>
);

export const PencilIcon = ({size = 18}) => (
    <Icon size={size}>
        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
    </Icon>
);

export const WhatsAppIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
    </Icon>
);

export const EnvelopeIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
    </Icon>
);

export const SearchIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
    </Icon>
);

/** Sort arrows: both for "not sorted by this", one for the direction when it is. */
export const SortIcon = ({direction = null, size = 14}) => (
    <Icon size={size}>
        {direction === "asc" && (
            <path d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5" />
        )}
        {direction === "desc" && (
            <path d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1" />
        )}
        {!direction && (
            <path d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5" />
        )}
    </Icon>
);

// The map pin, in Google Maps' red (it carries its own color, like the Pix symbol).
export const MapPinIcon = ({size = 16}) => (
    <span className="d-inline-flex" style={{color: "#EA4335"}}>
        <Icon size={size}>
            <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
        </Icon>
    </span>
);

export const InfoIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </Icon>
);

export const FunnelIcon = ({size = 16}) => (
    <Icon size={size}>
        <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
    </Icon>
);

// The Pix symbol, from the Banco Central's official logo (Pix (Brazil) logo.svg
// on Wikimedia Commons: public domain, a trademark of the Banco Central do
// Brasil). The symbol is cropped out of the logo and rendered to PNG without
// any redrawing: the brand manual forbids altering it, and a hand-drawn copy
// blurs at icon size. 24px is the size the manual gives as its minimum.
//
// Three resolutions (for 1x, 2x and 4x screens) keep it sharp everywhere.

export const PixIcon = ({size = 24}) => (
    <img
        src={pix1x}
        srcSet={`${pix1x} 1x, ${pix2x} 2x, ${pix4x} 4x`}
        width={size}
        height={size}
        alt=""
        aria-hidden="true"
        style={{display: "inline-block", verticalAlign: "middle"}}
    />
);
